<div class="d-flex align-items-center justify-content-center vh-100">
  <div class="text-center bg-bg-3 w-100" style="max-width: 500px;">
    <div class="container">
      <div class="p-16 bg-bg-2 justify-content-center">
        <div class="mb-8 fw-bold fs-4 text-primary"><img src="/assets/static/images/finreg-logo.svg" alt="" class="img-fluid"></div>
        <h5 class="mb-2 fw-semibold">Login</h5>

        <form (ngSubmit)="onSubmit()" [formGroup]="form" class="mb-3 mt-3 needs-validation">
          <p class="mb-3">{{ 'pages.signin.question' | translate }}</p>
          <div class="mb-3">
            <!--label class="form-label text-muted" for="username">{{ 'common.text.emailaddress' | translate }}</label-->
            <input class="form-control form-control-lg" formControlName="username" id="username" placeholder="name@example.com" type="username">
            <div *ngIf="submitted && f.username.errors" class="signin-form-error">
              <div *ngIf="f.username.errors['required']">Username is required</div>
              <div *ngIf="f.username.errors['email']">Username must be a valid email</div>
            </div>
          </div>
          <div class="mb-3">
            <!--label class="form-label text-muted" for="password">{{ 'common.text.password' | translate }}</label-->
            <input class="form-control form-control-lg" formControlName="password" id="password" placeholder="*******" type="password">
            <div *ngIf="submitted && f.password.errors" class="signin-form-error">
              <div *ngIf="f.password.errors['required']">Password is required</div>
              <div *ngIf="f.password.errors['minlength']">Password is required to be 7 characters long</div>
            </div>
          </div>
          <div class="d-grid">
            <button class="btn btn-action-2 rounded-1 w-100" type="submit">{{ 'common.buttons.login' | translate }}</button>
          </div>
        </form>

        <div class="mt-8">
          <small class="text-muted">{{ 'common.text.no_acc' | translate }}</small>
          <br>
          <a href="#" class="text-action-2 fw-semibold text-decoration-none" routerLink="/signup" target="_blank">{{ 'common.links.signup' | translate }}</a>
        </div>
      </div>
    </div>
  </div>
</div>
